// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_EXPERIENCE = "pridanie sk\u00fasenosti";
